import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  informacastm2mList (context, opts) {
    if (!context.state.fetchingList) {
      context.commit('INFORMACASTM2M_FETCHING_LIST', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/informacastm2m', { params: opts })
          .then(({ data }) => {
            context.commit('INFORMACASTM2M_LIST', data)
            resolve(data)
          })
          .catch((error) => reject(error))
          .finally(() => context.commit('INFORMACASTM2M_FETCHING_LIST', false))
      })
    }
  },
  // ==========================Socket Updates==============================
  informacastm2mCreated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    axios
      .get(`/api/informacastm2m/${id}`, inputs)
      .then(({ data }) => {
        data.socketUpdate = true
        context.commit('INFORMACASTM2M_LIST_ADD', data)
      }).catch(() => {
      })
  },
  informacastm2mUpdated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    const inList = context.state.list.find((i) => i.id === id)
    if (context.state.current.id === id || inList) {
      axios
        .get(`/api/informacastm2m/${id}`, inputs)
        .then(({ data }) => {
          if (data.id === context.state.current.id) {
            context.commit('INFORMACASTM2M_CURRENT', data)
          }
          if (inList) {
            context.commit('INFORMACASTM2M_LIST_UPDATE', data)
          }
        }).catch(() => {
        })
    }
  },
  informacastm2mDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('INFORMACASTM2M_CURRENT', null)
    }
    context.commit('INFORMACASTM2M_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  informacastm2mDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/informacastm2m/${id}`, inputs)
        .then(({ data }) => {
          context.commit('INFORMACASTM2M_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  informacastm2mUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if ((updates[key] === null || updates[key] === context.state.current[key]) && key !== 'id') {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/informacastm2m/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  bulkUpdateInformacastM2Ms (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/informacastm2m/bulkupdate', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
